import { z } from 'zod';

export const lookupAppointmentSchema = z.object({
  appointmentId: z
    .string()
    .uuid('ID do agendamento inválido'),
});

export type LookupAppointmentFormData = z.infer<typeof lookupAppointmentSchema>;
